module.exports = __webpack_public_path__ + "static/media/91LNaF-ADOL._AC_SL1500_.28910320.jpg";